import { getTimeFromDate } from './getTimeFromDate';
export const getInitialSelectedTimes = (selectedDates, calendarType) => {
    if (!selectedDates.length && calendarType === 'single') {
        return [getTimeFromDate(new Date())];
    }
    if (!selectedDates.length && calendarType === 'range') {
        return [getTimeFromDate(new Date()), getTimeFromDate(new Date())];
    }
    return selectedDates.map(getTimeFromDate);
};
